import React from "react";
import { MdInfo, MdClear } from "react-icons/md";

const EmptyState = ({
  icon: Icon = MdInfo,
  title,
  description,
  actionText,
  onAction,
  showResetFilters = false,
  onResetFilters,
  hasItems = false,
  hasActiveFilters = false,
}) => {
  return (
    <div className="col-span-full rounded-lg bg-white p-8 text-center shadow-sm">
      <div className="mx-auto mb-4 flex h-24 w-24 items-center justify-center rounded-full bg-green-50">
        <Icon className="text-5xl text-[#2ca01c]" />
      </div>

      <h3 className="mb-2 text-xl font-semibold text-gray-800">{title}</h3>

      <p className="mb-4 text-gray-600">{description}</p>

      {showResetFilters && hasItems && hasActiveFilters && (
        <button
          onClick={onResetFilters}
          className="mt-4 inline-flex items-center rounded-md bg-[#2ca01c] px-4 py-2 text-white transition-colors hover:bg-[#238615]"
        >
          <MdClear className="mr-2" /> Réinitialiser les filtres
        </button>
      )}

      {onAction && actionText && !hasItems && (
        <button
          onClick={onAction}
          className="mt-4 inline-flex items-center rounded-md bg-[#2ca01c] px-6 py-3 font-semibold text-white transition-colors hover:bg-[#238615]"
        >
          {actionText}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
